<i certTooltip="Edit" class="edit-icon me-2 float-start" (click)="update()"></i>
<i certTooltip="Delete" class="trash-icon-danger me-2 float-start" (click)="delete()"></i>
